"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.fields.model_composite': '选定模型',
};
